export const READ_WRITE = 'READ_WRITE';
export const READ = 'READ';
export const WRITE = 'WRITE';
//# sourceMappingURL=readWriteModes.js.map